// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_dc-0";